module.exports = __webpack_public_path__ + "static/media/pvm-outline.a5baf85b.svg";